import React from 'react';
import styled from 'styled-components';
import Container from 'components/layout/Container';
import logoCentro from 'img/logo-centro-energia.jpg'; //antes se usaba el .png, por eso se dejo en el repositorio

const HeaderMain = styled.div`
  background: #ffffff;
  border-bottom: 1px solid #e3e9f2;
  width: 100%;
`;

const Wrapper = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 96px;
  padding-top: 18px;
  padding-bottom: 18px;

  @media (max-width: 720px) {
    align-items: flex-start;
    gap: 14px;
    min-height: auto;
    padding-top: 16px;
    padding-bottom: 16px;
  }
`;

const TitleBlock = styled.div`
  max-width: 920px;
`;

const Eyebrow = styled.div`
  color: #7189ad;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  margin-bottom: 6px;
  text-transform: uppercase;
`;

const Title = styled.h1`
  color: #102f5f;
  font-size: 26px;
  font-weight: 800;
  line-height: 1.2;
  margin: 0;

  @media (max-width: 720px) {
    font-size: 20px;
  }
`;

const Subtitle = styled.p`
  color: #516887;
  font-size: 14px;
  line-height: 1.45;
  margin: 8px 0 0;

  @media (max-width: 720px) {
    font-size: 13px;
  }
`;

const Logos = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 0 0 180px;

  @media (max-width: 720px) {
    flex-basis: auto;
    justify-content: flex-start;
  }
`;

const CentroLogo = styled.img`
  display: block;
  width: 126px;

  @media (max-width: 720px) {
    width: 98px;
  }
`;

const Header = () => (
  <HeaderMain>
    <Wrapper>
      <TitleBlock>
        <Eyebrow>Modelo de proyección PMR</Eyebrow>
        <Title>
          Clúster de simulación de escenarios de mitigación de cambio climático
        </Title>
        <Subtitle>
          Plataforma interactiva para analizar proyecciones de oferta, demanda, emisiones e impacto de instrumentos de mitigación de GEI.
        </Subtitle>
      </TitleBlock>
      <Logos>
        <CentroLogo src={logoCentro} alt="Centro de Energía" />
      </Logos>
    </Wrapper>
  </HeaderMain>
);

export default Header;
